import { render } from "./TagMultiPicker.vue?vue&type=template&id=35937474&scoped=true&ts=true"
import script from "./TagMultiPicker.vue?vue&type=script&lang=ts"
export * from "./TagMultiPicker.vue?vue&type=script&lang=ts"

import "./TagMultiPicker.vue?vue&type=style&index=0&id=35937474&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35937474"]])

export default __exports__